<template>
    <div class="footer-wrap">
        <div class="main">
            <div class="footer-text">©2022 艾格云（北京）科技有限公司 版权所有</div>
            <div class='beian' @click="beian">京ICP备2022021270号-1</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
    props: {
    },
    methods:{
        beian(){
            window.location.href=`https://beian.miit.gov.cn/`
        }
    }
}
</script>
<style scoped>
.footer-wrap {
    background-color: #F5F5F5;
    font-size: 0.14rem;
    text-align: center;
    height: 100%;
}

.main{
    padding-top:0.25rem ;
}
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.beian{
   cursor: pointer;
}
</style>